import {
  fetchData,
  withFilteredCatalogue,
  withFilteredPrizes,
} from "../../Helpers";
import DOMPurify from "dompurify";

export const PRIZE_STALE_TIME = 1000 * 60 * 5.5;
export const PRIZE_CACHE_TIME = Infinity;
export const COUNT_PRIZE_STALE_TIME = 1000 * 60 * 5.5;
export const COUNT_PRIZE_CACHE_TIME = Infinity;
export const CATALOUGE_STALE_TIME = 1000 * 60 * 5.5;
export const CATALIUGE_CACHE_TIME = Infinity;

export const REDDEM_REFERRAL_PRIZE_STALE_TIME = 1000 * 60 * 5.5;
export const REDDEM_REFERRAL_PRIZE_CACHE_TIME = Infinity;

export async function getReferralPrizeList() {
  const controller = new AbortController();
  const result = await fetchData({
    endpoint: "/prize/referral/list",
    successCallback: () => {},
    controller: controller,
  });

  return withFilteredPrizes(result);
}
export function getReferralPrizeCount({ payload }) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/prize/referral/count",
    successCallback: () => {},
    controller: controller,
    payload,
  });
}
export async function getCatalougeReferralList() {
  const controller = new AbortController();
  const result = await fetchData({
    endpoint: "/prize/catalogue/referral/list",
    successCallback: () => {},
    controller: controller,
  });

  return withFilteredCatalogue(result);
}

export function redeemReferralPrize({
  payload,
  successCallback,
  errorCallback,
}) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/prize/referral/redeem",
    controller: controller,
    successCallback: (data) => {
      successCallback(data);
    },
    errorCallback: (error) => {
      errorCallback(error);
    },
    payload,
  });
}
export async function getPrizeCatalogueList(
  payload = {
    limit: 100,
    offset: 0,
    expired: false,
  },
) {
  const controller = new AbortController();
  const result = await fetchData({
    endpoint: "/prize/catalogue/list",
    payload,
    successCallback: () => {},
    controller: controller,
  });

  return withFilteredCatalogue(result);
}

export function getPrizeCatalogueDescribe(ident) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/prize/catalogue/describe",
    payload: {
      catalogue: {
        ident: DOMPurify.sanitize(ident),
      },
    },
    successCallback: () => {},
    controller: controller,
  });
}

export function getPrizeCount(expired = null) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/prize/count",
    payload: { expired },
    successCallback: () => {},
    controller: controller,
  });
}

export async function getPrizeList(
  payload = {
    limit: 100,
    offset: 0,
    expired: false,
  },
  options = {},
) {
  const { includeGameRewards = false } = options;
  const controller = new AbortController();
  const result = await fetchData({
    endpoint: "/prize/list",
    payload,
    successCallback: () => {},
    controller: controller,
  });

  return includeGameRewards ? result : withFilteredPrizes(result);
}

export function getPrizeDescribe(uuid) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/prize/describe",
    payload: {
      prize: {
        uuid: DOMPurify.sanitize(uuid),
      },
    },
    successCallback: () => {},
    controller: controller,
  });
}

export function redeemPrize(uuid) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/prize/redeem",
    payload: {
      prize: {
        uuid: DOMPurify.sanitize(uuid),
      },
    },
    successCallback: () => {},
    controller: controller,
  });
}

export async function getUltraInsiderPrizeList(options = {}) {
  const { includeGameRewards = false, ...payload } = options;
  const controller = new AbortController();
  const result = await fetchData({
    endpoint: "/prize/insider/list",
    payload: {
      expired: false,
      ...payload,
    },
    successCallback: () => {},
    controller: controller,
  });

  return includeGameRewards ? result : withFilteredPrizes(result);
}

export function redeemUltraInsider(uuid) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/prize/insider/redeem",
    payload: {
      prize: {
        uuid: DOMPurify.sanitize(uuid),
      },
    },
    successCallback: () => {},
    controller: controller,
  });
}
